import { CommonTabs } from '../../../components/tabs';
import getFormatMessage from '../../../locales/get-format-message';

export enum OrganizationTab {
  Members = 'Members',
  Roles = 'Roles',
}

interface ITabItem {
  readonly key: OrganizationTab;
  readonly label: string;
}

interface IProps {
  readonly tabKey: OrganizationTab;
  readonly onChange: (tabKey: OrganizationTab) => void;
  readonly className: string;
  readonly membersLength: number;
  readonly rolesLength: number;
}

export const OrganizationTabs = (props: IProps) => {
  const items: ITabItem[] = [
    {
      key: OrganizationTab.Members,
      label: `${getFormatMessage('members')} (${props.membersLength})`,
    },

    {
      key: OrganizationTab.Roles,
      label: `${getFormatMessage('roles')} (${props.rolesLength})`,
    },
  ];

  const onTabChange = (key: string) => {
    props.onChange(key as unknown as OrganizationTab);
  };

  return (
    <div className={props.className}>
      <CommonTabs
        activeKey={props.tabKey as unknown as string}
        items={items as any}
        onChange={onTabChange}
      ></CommonTabs>
    </div>
  );
};
